import React from 'react';
import './Payroll.css';
import usePayroll from './payroll/usePayroll';
import PayrollSidebar from './payroll/PayrollSidebar';
import PayrollTopBar from './payroll/PayrollTopBar';
import PayrollTabs from './payroll/PayrollTabs';
import PersonalTab from './payroll/PersonalTab';
import SalaryTab from './payroll/SalaryTab';
import ActivityTab from './payroll/ActivityTab';
import DocumentsTab from './payroll/DocumentsTab';
import SalarySlipModal from './payroll/SalarySlipModal';

export default function Payroll() {
  const p = usePayroll();

  return (
    <div className="pr-root">
      {/* Sidebar */}
      <PayrollSidebar
        users={p.filteredUsers}
        selectedUser={p.selectedUser}
        onUserClick={p.handleUserClick}
        searchTerm={p.searchTerm}
        onSearchChange={p.setSearchTerm}
        getUserId={p.getUserId}
      />

      {/* Main Panel */}
      <div className="pr-main">
        {!p.selectedUser && (
          <div className="pr-empty">
            <div className="pr-empty-icon">&#128100;</div>
            <h3>Select an Employee</h3>
            <p>Choose a staff member from the sidebar to view their info and payroll</p>
          </div>
        )}

        {p.selectedUser && (
          <>
            <PayrollTopBar
              selectedUser={p.selectedUser}
              salaryState={p.salaryState}
              workingDaysOfMonth={p.workingDaysOfMonth}
              showThirdColumn={p.showThirdColumn}
            />

            <PayrollTabs
              activeTab={p.activeTab}
              onTabChange={p.setActiveTab}
            />

            <div className="pr-content">
              {p.activeTab === 'personal' && (
                <PersonalTab
                  selectedUser={p.selectedUser}
                  updateSelectedUserField={p.updateSelectedUserField}
                  savePersonalInfo={p.savePersonalInfo}
                />
              )}

              {p.activeTab === 'activity' && (
                <ActivityTab
                  selectedUser={p.selectedUser}
                  selectedMonth={p.selectedMonth}
                  prevMonth={p.prevMonth}
                  nextMonth={p.nextMonth}
                  getUserId={p.getUserId}
                />
              )}

              {p.activeTab === 'payroll' && (
                <SalaryTab
                  selectedUser={p.selectedUser}
                  selectedMonth={p.selectedMonth}
                  salaryState={p.salaryState}
                  workingDaysOfMonth={p.workingDaysOfMonth}
                  showThirdColumn={p.showThirdColumn}
                  loading={p.loading}
                  saving={p.saving}
                  sampleData={p.sampleData}
                  isCurrentMonth={p.isCurrentMonth}
                  getBonusForMonth={p.getBonusForMonth}
                  sumComponentsToBePaid={p.sumComponentsToBePaid}
                  sumBonusesToBePaid={p.sumBonusesToBePaid}
                  getBackendValue={p.getBackendValue}
                  updateBonusField={p.updateBonusField}
                  updateComponentValue={p.updateComponentValue}
                  generateSalary={p.generateSalary}
                  saveSalaryStructure={p.saveSalaryStructure}
                  savePayroll={p.savePayroll}
                  printSalarySlip={p.printSalarySlip}
                  prevMonth={p.prevMonth}
                  nextMonth={p.nextMonth}
                  payrollStatusForMonth={p.payrollStatusForMonth}
                  setSalaryState={p.setSalaryState}
                />
              )}

              {p.activeTab === 'documents' && (
                <DocumentsTab username={p.selectedUser.username} />
              )}
            </div>
          </>
        )}
      </div>

      {/* Salary Slip Modal */}
      <SalarySlipModal
        show={p.showSlipModal}
        slipHTML={p.slipHTML}
        onClose={function () { p.setShowSlipModal(false); }}
        onPrint={p.handlePrintSlip}
      />
    </div>
  );
}
